module.exports = __webpack_public_path__ + "static/media/Inter-Thin.be37c2eb.ttf";